type ScratchcardCategory = 'all_scratchcards' | 'popular' | 'budget' | 'millionaire' | 'best_odds' | 'lottery' | 'special' | 'charity';

const SCRATCHCARD_API_CATEGORY: Record<ScratchcardCategory, string> = {
  all_scratchcards: 'All',
  popular: 'Popular',
  budget: 'Budget',
  millionaire: 'Millionaire',
  best_odds: 'BestOdds',
  lottery: 'Lottery',
  special: 'Special',
  charity: 'Charity',
};

export { SCRATCHCARD_API_CATEGORY, type ScratchcardCategory };
